import { NavMarker } from 'react-rhumb';
import { useAppSelector } from '../../../reducers';
import { hasPricingAndPurchasingSucceededSelector } from '../../../selectors/LoadingStateSelectors';
import ProductInfoContainer from '../../common/ProductInfoContainer';
import MobileCurrencyPicker from '../MobileCurrencyPicker';
import MobileDropdownNav from '../MobileDropdownNav';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileWrapperNoTabs = ({
  navMarkerName,
  navItem,
  children
}) => {
  const hasPricingAndPurchasingSucceeded = useAppSelector(hasPricingAndPurchasingSucceededSelector);
  return /*#__PURE__*/_jsxs("div", {
    "data-selenium-id": "page-success",
    children: [hasPricingAndPurchasingSucceeded && /*#__PURE__*/_jsx(NavMarker, {
      name: navMarkerName
    }), /*#__PURE__*/_jsx(MobileCurrencyPicker, {}), /*#__PURE__*/_jsx(MobileDropdownNav, {
      selectedNavItem: navItem
    }), /*#__PURE__*/_jsx(ProductInfoContainer, {
      children: children
    })]
  });
};
export default MobileWrapperNoTabs;